const KEY = "tenx_pending_plan";
export const PLAN_NAMES = { growth: "Growth", scale: "Scale", fund_manager: "Fund Manager" };

export const savePendingPlan = (plan, interval) => sessionStorage.setItem(KEY, JSON.stringify({ plan, interval }));
export const clearPendingPlan = () => sessionStorage.removeItem(KEY);
export const readPendingPlan = () => {
  try {
    const value = JSON.parse(sessionStorage.getItem(KEY) || "null");
    return value && PLAN_NAMES[value.plan] && ["monthly", "yearly"].includes(value.interval) ? value : null;
  } catch { return null; }
};
export const describePendingPlan = (p) => `${PLAN_NAMES[p.plan]}, billed ${p.interval === "yearly" ? "annually" : "monthly"}`;
